/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalculateCryptoWithdrawalFeeDto } from '../models/CalculateCryptoWithdrawalFeeDto';
import type { CreateCryptoWithdrawalBaseDto } from '../models/CreateCryptoWithdrawalBaseDto';
import type { CreateCryptoWithdrawalDto } from '../models/CreateCryptoWithdrawalDto';
import type { CryptoWithdrawalFeeDto } from '../models/CryptoWithdrawalFeeDto';
import type { CryptoWithdrawalRequestDto } from '../models/CryptoWithdrawalRequestDto';
import type { CustomerBatchTransactionDto } from '../models/CustomerBatchTransactionDto';
import type { TwoFactorAuthRequestDto } from '../models/TwoFactorAuthRequestDto';
import type { WithdrawalBatchConfirmationDto } from '../models/WithdrawalBatchConfirmationDto';
import type { WithdrawalBatchCreateSummary } from '../models/WithdrawalBatchCreateSummary';
import type { WithdrawalBatchDtoPaginationResultDto } from '../models/WithdrawalBatchDtoPaginationResultDto';
import type { WithdrawalBatchStatus } from '../models/WithdrawalBatchStatus';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class CryptoWithdrawalsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns CryptoWithdrawalFeeDto Success
     * @throws ApiError
     */
    public postApiCryptoWithdrawalsFee(
        requestBody?: CalculateCryptoWithdrawalFeeDto,
    ): CancelablePromise<CryptoWithdrawalFeeDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-withdrawals/fee',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @deprecated
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public postApiCryptoWithdrawalsSmsConfirmations(
        requestBody?: CreateCryptoWithdrawalBaseDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-withdrawals/sms-confirmations',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                429: `Too Many Requests`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CryptoWithdrawalRequestDto Created
     * @throws ApiError
     */
    public postApiCryptoWithdrawals(
        requestBody?: CreateCryptoWithdrawalDto,
    ): CancelablePromise<CryptoWithdrawalRequestDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-withdrawals',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param formData
     * @returns WithdrawalBatchCreateSummary Created
     * @throws ApiError
     */
    public postApiCryptoWithdrawalsBatches(
        formData?: {
            file: Blob;
        },
    ): CancelablePromise<WithdrawalBatchCreateSummary> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-withdrawals/batches',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param withdrawalBatchStatuses
     * @param page
     * @param count
     * @returns WithdrawalBatchDtoPaginationResultDto Success
     * @throws ApiError
     */
    public getApiCryptoWithdrawalsBatches(
        withdrawalBatchStatuses?: Array<WithdrawalBatchStatus>,
        page: number = 1,
        count: number = 10,
    ): CancelablePromise<WithdrawalBatchDtoPaginationResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/crypto-withdrawals/batches',
            query: {
                'withdrawalBatchStatuses': withdrawalBatchStatuses,
                'page': page,
                'count': count,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param withdrawalBatchId
     * @param requestBody
     * @returns WithdrawalBatchConfirmationDto Accepted
     * @throws ApiError
     */
    public postApiCryptoWithdrawalsBatchesConfirmation(
        withdrawalBatchId: number,
        requestBody?: TwoFactorAuthRequestDto,
    ): CancelablePromise<WithdrawalBatchConfirmationDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-withdrawals/batches/{withdrawalBatchId}/confirmation',
            path: {
                'withdrawalBatchId': withdrawalBatchId,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param withdrawalBatchId
     * @returns CustomerBatchTransactionDto Created
     * @throws ApiError
     */
    public getApiCryptoWithdrawalsBatches1(
        withdrawalBatchId: number,
    ): CancelablePromise<Array<CustomerBatchTransactionDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/crypto-withdrawals/batches/{withdrawalBatchId}',
            path: {
                'withdrawalBatchId': withdrawalBatchId,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
